import { isEmpty } from 'lodash';
import { useCallback, useState } from 'react';

import {
  AgendaAvailableItemDataFragment,
  AgendaAvailableSlotItemDataFragment,
  BaseHealthProfessionalItemFragment,
  ConsultType,
} from '../../../data/types/api/graphql';
import { CustomFormattedDate } from '../../../elements/intl/custom-formatted-date';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { AgendaAvailableBlockListItem } from './agenda-available-block-list-item';

type AgendaAvailableBlockListProps = {
  loading?: boolean;
  items: AgendaAvailableItemDataFragment[];
  consultType: ConsultType;
  showAsRange?: boolean;
  compact?: boolean;
  multiple?: boolean;
  date?: string;
  value?: {
    healthProfessionalId: string | null | undefined;
    selectedSlots: AgendaAvailableSlotItemDataFragment[];
  };
  onClick?: (
    healthProfessional: BaseHealthProfessionalItemFragment,
    slots: AgendaAvailableSlotItemDataFragment[]
  ) => void;
};

export function AgendaAvailableBlockList({
  loading = false,
  date,
  showAsRange,
  consultType,
  compact,
  items,
  multiple,
  onClick,
  value,
}: AgendaAvailableBlockListProps) {
  // const items = useMemo(() => props.items, [props.items]);

  const [active, setActive] = useState<string>(
    value?.healthProfessionalId ?? ''
  );

  const onHandleActive = useCallback((activeValue: string) => {
    setActive(activeValue);
  }, []);

  // set active healthprofessional
  /*
  useEffect(() => {
    onHandleActive(value?.healthProfessionalId ?? '');
  }, [onHandleActive, value?.healthProfessionalId]); */

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    if (date) {
      if (!isEmpty(date)) {
        return (
          <p>
            <CustomFormattedMessage
              id="agenda.appointment.no-slot-available-for-date"
              values={{
                date: <CustomFormattedDate value={date} weekday="long" />,
              }}
            />
          </p>
        );
      }
    }

    return (
      <p>
        <CustomFormattedMessage id="agenda.appointment.no-data" />
      </p>
    );
  }

  return (
    <div className="agenda-appointment-block-list">
      {items.map(option => (
        <div
          key={option.healthProfessional.id}
          className="agenda-appointment-block-list__item"
        >
          <AgendaAvailableBlockListItem
            compact={compact}
            consultType={consultType}
            multiple={multiple}
            showAsRange={showAsRange}
            active={option.healthProfessional.id === active}
            agendaBlockItem={option}
            value={value}
            onActive={onHandleActive}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  );
}
